import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { CheckCircle2 } from 'lucide-react';

// Reached after a cart submission. Nothing has been charged at this point —
// the shop reviews the request and emails an invoice, so the copy is
// deliberately "request received", not "order confirmed".
const OrderConfirmation: React.FC = () => {
  const [params] = useSearchParams();
  const orderNumber = params.get('order_number');
  const email = params.get('email');

  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-16 text-center">
      <CheckCircle2 className="w-12 h-12 text-primary mx-auto mb-4" />
      <h1 className="text-3xl font-semibold mb-2">We got your request!</h1>

      {orderNumber ? (
        <>
          <p className="text-text-light">
            Your request number is{' '}
            <span className="font-medium text-text font-mono">{orderNumber}</span>.
            {email && <> We sent a copy to <span className="font-medium">{email}</span>.</>}
          </p>
          <p className="text-text-light mt-3">
            We'll review the details and email you an invoice with the final total,
            including shipping. Nothing has been charged yet.
          </p>
          <div className="mt-6 inline-block text-left bg-background-dark/30 border border-background-dark rounded px-4 py-3 text-sm text-text-light">
            Hang on to your request number — you'll need it (with your email) to
            check status or view your invoice.
          </div>
        </>
      ) : (
        <p className="text-text-light">
          We'll review the details and email you an invoice with the final total.
          Nothing has been charged yet.
        </p>
      )}

      <div className="mt-8 flex flex-wrap justify-center items-center gap-3">
        <Link to="/shop" className="text-primary hover:underline">
          Continue shopping
        </Link>
        <span className="text-text-light">·</span>
        <Link to="/order/status" className="text-primary hover:underline">
          Check request status
        </Link>
        {orderNumber && email && (
          <>
            <span className="text-text-light">·</span>
            <Link
              to={`/invoice/${encodeURIComponent(orderNumber)}?email=${encodeURIComponent(email)}`}
              className="text-primary hover:underline"
            >
              View request
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default OrderConfirmation;
